import { Controller } from '@hotwired/stimulus'

export default class ConfirmModalController extends Controller {
  static targets = ['modal', 'confirmLink', 'content']

  connect() {
    this.modal = new bootstrap.Modal(this.modalTarget);

    this.clickHandler = this.handleGlobalClick.bind(this);
    document.addEventListener('click', this.clickHandler);
  }

  disconnect() {
    document.removeEventListener('click', this.clickHandler);
  }

  handleGlobalClick(event) {
    const button = event.target.closest('[data-confirm-href]');

    if (button) {
      event.preventDefault();
      event.stopPropagation();

      const fakeEvent = { currentTarget: button };
      this.openModal(fakeEvent);
    }
  }

  openModal(event) {
    const { confirmHref, modalContent, method } = event.currentTarget.dataset;

    this.contentTarget.innerText = modalContent;
    this.confirmLinkTarget.href = confirmHref;
    this.confirmLinkTarget.setAttribute("data-method", method || "post");
    this.modal.show();
  }
}
